import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sahumerios que duran 48 horas',
    cost: 'Dinero gastado sin resultado permanente'
  }, {
    without: 'Dormir mal noche tras noche',
    cost: 'Salud deteriorándose sin entender por qué'
  }, {
    without: 'Conflictos que se repiten en el mismo lugar',
    cost: 'Relaciones desgastadas por la energía del ambiente'
  }, {
    without: 'Plantas que mueren, mascotas inquietas',
    cost: 'Señales ignoradas que empeoran'
  }, {
    without: 'Llamar a alguien para que limpie tu casa',
    cost: '$15.000+ cada vez, sin aprender a hacerlo vos'
  }, {
    without: 'Otro año en el mismo ambiente pesado',
    cost: 'Tu hogar debería ser tu refugio, no tu carga'
  }];
  return <Section data-id="element-46">
      <div className="text-center mb-12" data-id="element-47">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-48">
          <span className="mr-3" data-id="element-49">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-50">
        {/* Desktop: 2-column grid */}
        <div className="hidden md:block" data-id="element-51">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
            <div className="font-serif font-bold text-lg text-brand-text/90" data-id="element-53">
              Sin el Sistema
            </div>
            <div className="font-serif font-bold text-lg text-red-500" data-id="element-54">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-55">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-red-500/20" data-id="element-56">
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-57">
                  {row.without}
                </div>
                <div className="text-sm text-red-600/90" data-id="element-58">{row.cost}</div>
              </div>)}
          </div>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-4" data-id="element-59">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-2 border-red-500/20 pt-[10px] pb-[10px] pl-[10px] pr-[10px]" data-id="element-60">
              <p className="text-sm font-medium text-brand-text" data-id="element-61">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-red-600/90" data-id="element-62">
                <span className="text-red-500 shrink-0" data-id="element-63">→</span>
                <span className="text-sm" data-id="element-64">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-65">
        <h3 className="md:text-3xl font-serif font-bold gold-gradient-text mb-6 text-[20px]" data-id="element-66">
          La próxima noche puede ser completamente diferente.
        </h3>
        <p className="italic text-brand-text/80 text-[16px]" data-id="element-67">
          "Tu hogar limpio no es el destino. Es el punto de partida." 🌟
        </p>
      </div>
    </Section>;
};